import React, { useRef } from 'react';
import Popover from 'jd-library/Popover';
import FormSwitch from 'jd-library/FormSwitch';
import styles from './medical-prescription.scss';
import { connect } from "react-redux";
import { updateEditProductDetail } from '../../../actions/products';

const MedicalPrescription = ({isPrescriptionRequired, updateEditProductDetail}) => {
    let containerRef = useRef();
    return (
        <div className={styles["medical-prescription"]} ref={containerRef}>
            <div className={styles["heading-popover"]}>
                {"Medical Prescription Required"}
                <Popover
                    content={
                        <div className={`popover-holder`}>
                            {
                                "Customer will be prompted to upload medical prescription if they have selected a product which requires prescription"
                            }
                        </div>
                    }
                    className="popover-div"
                    containerEle={containerRef}
                >
                    <div className={styles["popover-icon"]}>
                        <i className="icon-Info"></i>
                    </div>
                </Popover>
            </div>
            <div className={styles["form-switch-holder"]}>
                <FormSwitch
                    checked={isPrescriptionRequired}
                    showToggleStatus={isPrescriptionRequired}
                    onClick={event => {
                        updateEditProductDetail([{
                            key: 'isPrescriptionRequired',
                            value: event.target.checked
                        }]);
                    }}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        ...props,
        variantPresent: state.variants.variantProductData.length > 0,
        isPrescriptionRequired: props.productData?.isPrescriptionRequired || false
    };
};

const mapDispatchToProps = {
    updateEditProductDetail
};

export default connect(mapStateToProps, mapDispatchToProps)(MedicalPrescription);